import React from 'react';
import Box from '@mui/material/Box';
import { useOrganizationDetails } from './hooks';
import type { OrganizationDetailTab } from './interfaces';
import { BillingHistoryTab } from './containers/BillingHistoryTab';
import { BillingSubscriptionTab } from './containers/BillingSubscriptionTab';
import { DetailsHeader } from './containers/DetailsHeader';
import { OverviewTab } from './containers/OverviewTab';
import { PermissionsTab } from './containers/PermissionsTab';
import { SecurityLogTab } from './containers/SecurityLogTab';
import { UsersTab } from './containers/UsersTab';

const renderTabContent = (activeTab: OrganizationDetailTab) => {
  switch (activeTab) {
    case 'Overview':
      return <OverviewTab />;
    case 'Billing & Subscription':
      return <BillingSubscriptionTab />;
    case 'Billing History':
      return <BillingHistoryTab />;
    case 'Users':
      return <UsersTab />;
    case 'Permissions':
      return <PermissionsTab />;
    case 'Security Log':
      return <SecurityLogTab />;
    default:
      return <OverviewTab />;
  }
};

export const OrganizationDetails: React.FC = () => {
  const details = useOrganizationDetails();

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1600, mx: 'auto' }}>
        <DetailsHeader
          organization={details.organization}
          tabs={details.tabs}
          activeTab={details.activeTab}
          onTabChange={details.setActiveTab}
        />

        {renderTabContent(details.activeTab)}
      </Box>
    </Box>
  );
};

export default OrganizationDetails;
